"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var form_constants_1 = require("../form-constants");
var form_input_element_base_1 = require("./form-input-element-base");
var MultipleChoiceOption = /** @class */ (function () {
    function MultipleChoiceOption() {
    }
    return MultipleChoiceOption;
}());
exports.MultipleChoiceOption = MultipleChoiceOption;
exports.MultipleChoiceOptionRecord = immutable_1.Record({
    value: '',
    label: '',
    numValue: ''
});
var ImmutableMultipleChoiceOption = /** @class */ (function (_super) {
    __extends(ImmutableMultipleChoiceOption, _super);
    function ImmutableMultipleChoiceOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ImmutableMultipleChoiceOption;
}(exports.MultipleChoiceOptionRecord));
exports.ImmutableMultipleChoiceOption = ImmutableMultipleChoiceOption;
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.radio, optionsList: immutable_1.List([]), otherOptionValue: undefined, otherTextElementId: undefined });
exports.MultipleChoiceElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableMultipleChoiceElement = /** @class */ (function (_super) {
    __extends(ImmutableMultipleChoiceElement, _super);
    function ImmutableMultipleChoiceElement(props) {
        return _super.call(this, __assign({}, props, { optionsList: immutable_1.List(props.options.map(function (option) { return new ImmutableMultipleChoiceOption(option); })) })) || this;
    }
    Object.defineProperty(ImmutableMultipleChoiceElement.prototype, "options", {
        // Initialize options after optionsList is defined
        get: function () {
            return this.optionsList.toArray();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * creates a clone of the current ImmutableMultipleChoiceElement
     * @param key property to change
     * @param value value that the property will be set to
     */
    ImmutableMultipleChoiceElement.prototype.set = function (key, value) {
        var result = _super.prototype.set.call(this, key, value);
        var object = result.toObject();
        return new ImmutableMultipleChoiceElement(object);
    };
    /** makes sure that converting this to an object includes the options array */
    ImmutableMultipleChoiceElement.prototype.toObject = function () {
        var object = _super.prototype.toObject.call(this);
        object.options = object.optionsList.toArray();
        return object;
    };
    return ImmutableMultipleChoiceElement;
}(exports.MultipleChoiceElementRecord));
exports.ImmutableMultipleChoiceElement = ImmutableMultipleChoiceElement;
//# sourceMappingURL=multiple-choice-element.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/multiple-choice-element.js
// module id = 1141
// module chunks = 0